export default __webpack_public_path__ + "static/Custom-Solutions-8b4a289a63351400a99535d9690e12b5.webp";